import React from "react";
import {Link} from 'react-router-dom'
import './DesignSub.css'
import {withRouter} from 'react-router'


import Graceling from '../Images/Design/GracelingBookCover.jpg'
import HNTFIL from '../Images/Design/HNTFILBookCover.jpg'
import MicahSummers from '../Images/Design/99BoyfriendsofMicahSummersBookCover.jpg'
import BeautyandtheBesharam from '../Images/Design/BeautyandtheBesharamBookCover.jpg'
import TheSeaKnowsmyName from '../Images/Design/TheSeaKnowsmyNameBookCover.jpg'
import TheVanishingDeep from '../Images/Design/TheVanishingDeepBookCover.jpg'
import ZylaandKai from '../Images/Design/ZylaandKaiBookCover.jpg'
import MostDazzlingGirlinBerlin from '../Images/Design/MostDazzlingGirlinBerlinBookCover.jpg'
import WalkonBy from '../Images/Design/AsYouWalkonByBookCover.jpg'
import WishUponLantern from '../Images/Design/WhenYouWishUponaLanternBookCover.jpg'
import LightEnoughtoFloat from '../Images/Design/LightEnoughtoFloatBookCover.jpg'
import RulesforRuleBreaking from '../Images/Design/RulesforRuleBreakingBookCover.jpg'
import FromLittleTokyoWithLove from '../Images/Design/FromLittleTokyoWithLoveBookCover.jpg'
import YourLonelyNightsareOver from '../Images/Design/YourLonelyNightsareOverBookCover.jpg'
import SuddenlyaMurder from '../Images/Design/SuddenlyaMurderBookCover.jpg'
import TheBreakupLists from '../Images/Design/TheBreakupListsBookCover.jpg'
import CursedBoysandBrokenHearts from '../Images/Design/CursedBoysandBrokenHeartsBookCover.jpg'
import TheSecretWorldofBriarRose from '../Images/Design/TheSecretWorldofBriarRose_Bookcover.jpg'
import GirlReflectedinKnife from '../Images/Design/GirlReflectedinKnife_Bookcover.jpg'
import SoloStan from '../Images/Design/SoloStan_Bookcover.jpg'
import FindMyWayDowntoYou from '../Images/Design/FindMyWayDowntoYou_Bookcover.jpg'
import MothDark from '../Images/Design/MothDark_Bookcover.jpg'
import GiveMeASign from '../Images/Design/GiveMeASign_Bookcover.jpg'
import OntheBrightSide from '../Images/Design/OntheBrightSide_Bookcover.jpg'
import TimeAfterTime from '../Images/Design/TimeAfterTime_Bookcover.jpg'
import DeathCard from '../Images/Design/DeathCard_Bookcover.jpg'
import ProdigalTiger from '../Images/Design/ProdigalTiger_Bookcover.jpg'
import Heartsick from '../Images/Design/Heartsick_Bookcover.jpg'
import VeryDangerousThings from '../Images/Design/VeryDangerousThings_Bookcover.jpg'




const YoungAdult = props => {
	return(
		<div>
			<div class="design-grid-container">
				<div class="designProject">
		    		<img className="designImage"src={TheSecretWorldofBriarRose} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/TheSecretWorldofBriarRose"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={LightEnoughtoFloat} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/LightEnoughtoFloat"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={RulesforRuleBreaking} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/RulesforRuleBreaking"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={GirlReflectedinKnife} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/GirlReflectedinKnife"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={SoloStan} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/SoloStan"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={FindMyWayDowntoYou} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/FindMyWayDowntoYou"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={MothDark} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/MothDark"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={GiveMeASign} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/GiveMeASign"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={OntheBrightSide} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/OntheBrightSide"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={TimeAfterTime} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/TimeAfterTime"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={DeathCard} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/DeathCard"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={ProdigalTiger} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/ProdigalTiger"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={Heartsick} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/Heartsick"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={VeryDangerousThings} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/VeryDangerousThings"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={FromLittleTokyoWithLove} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/FromLittleTokyoWithLove"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={WishUponLantern} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/WishUponLantern"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={YourLonelyNightsareOver} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/YourLonelyNightsareOver"></a>
		    		</div>
		    	</div>
				<div class="designProject">
		    		<img className="designImage"src={WalkonBy} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/AsYouWalkonBy"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={SuddenlyaMurder} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/SuddenlyaMurder"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={TheBreakupLists} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/TheBreakupLists"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={CursedBoysandBrokenHearts} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/CursedBoysandBrokenHearts"></a>
		    		</div>
		    	</div>
				
				
				<div class="designProject">
		    		<img className="designImage"src={MicahSummers} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/99BoyfriendsofMicahSummers"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={MostDazzlingGirlinBerlin} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/MostDazzlingGirlinBerlin"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={ZylaandKai} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/ZylaandKai"></a>
		    		</div>
		    	</div>		    	
		    	<div class="designProject">
		    		<img className="designImage"src={BeautyandtheBesharam} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/BeautyandtheBesharam"></a>
		    		</div>
		    	</div>
		    	<div class="designProject"> 
		    		<img className="designImage"src={TheSeaKnowsmyName} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/TheSeaKnowsmyName"></a>
		    		</div>
		    	</div>		    	
		    	<div class="designProject">
		    		<img className="designImage"src={TheVanishingDeep} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/TheVanishingDeep"></a>
		    		</div>
		    	</div>
		    	<div class="designProject">
		    		<img className="designImage"src={HNTFIL} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/HowNotToFallinLove"></a>
		    		</div>
		    	</div>

		    	<div class="designProject">
		    		<img className="designImage"src={Graceling} loading="lazy"/>
		    		<div class="designOverlay">
		    			<a href="/BookDesign/Graceling"></a>
		    		</div>
		    	</div>

		    </div>

			<div className="design-mobile">
				<a href="/BookDesign/TheSecretWorldofBriarRose"><img className="designImage"src={TheSecretWorldofBriarRose} loading="lazy"/></a>
				<a href="/BookDesign/LightEnoughtoFloat"><img className="designImage"src={LightEnoughtoFloat} loading="lazy"/></a>
				<a href="/BookDesign/RulesforRuleBreaking"><img className="designImage"src={RulesforRuleBreaking} loading="lazy"/></a>
				<a href="/BookDesign/GirlReflectedinKnife"><img className="designImage"src={GirlReflectedinKnife} loading="lazy"/></a>
				<a href="/BookDesign/SoloStan"><img className="designImage"src={SoloStan} loading="lazy"/></a>
				<a href="/BookDesign/FindMyWayDowntoYou"><img className="designImage"src={FindMyWayDowntoYou} loading="lazy"/></a>
				<a href="/BookDesign/MothDark"><img className="designImage"src={MothDark} loading="lazy"/></a>
				<a href="/BookDesign/GiveMeASign"><img className="designImage"src={GiveMeASign} loading="lazy"/></a>
				<a href="/BookDesign/OntheBrightSide"><img className="designImage"src={OntheBrightSide} loading="lazy"/></a>
				<a href="/BookDesign/TimeAfterTime"><img className="designImage"src={TimeAfterTime} loading="lazy"/></a>
				<a href="/BookDesign/DeathCard"><img className="designImage"src={DeathCard} loading="lazy"/></a>
				<a href="/BookDesign/ProdigalTiger"><img className="designImage"src={ProdigalTiger} loading="lazy"/></a>
				<a href="/BookDesign/Heartsick"><img className="designImage"src={Heartsick} loading="lazy"/></a>
				<a href="/BookDesign/VeryDangerousThings"><img className="designImage"src={VeryDangerousThings} loading="lazy"/></a>
				<a href="/BookDesign/CursedBoysandBrokenHearts"><img className="designImage"src={CursedBoysandBrokenHearts} loading="lazy"/></a>
				<a href="/BookDesign/TheBreakupLists"><img className="designImage"src={TheBreakupLists} loading="lazy"/></a>
				<a href="/BookDesign/SuddenlyaMurder"><img className="designImage"src={SuddenlyaMurder} loading="lazy"/></a>
				<a href="/BookDesign/YourLonelyNightsareOver"><img className="designImage"src={YourLonelyNightsareOver} loading="lazy"/></a>
				<a href="/BookDesign/FromLittleTokyoWithLove"><img className="designImage"src={FromLittleTokyoWithLove} loading="lazy"/></a>
				<a href="/BookDesign/WishUponLantern"><img className="designImage"src={WishUponLantern} loading="lazy"/></a>
				<a href="/BookDesign/AsYouWalkonBy"><img className="designImage"src={WalkonBy} loading="lazy"/></a>
				<a href="/BookDesign/99BoyfriendsofMicahSummers"><img className="designImage"src={MicahSummers} loading="lazy"/></a>
				<a href="/BookDesign/BeautyandtheBesharam"><img className="designImage"src={BeautyandtheBesharam} loading="lazy"/></a>
				<a href="/BookDesign/TheSeaKnowsmyName"><img className="designImage"src={TheSeaKnowsmyName} loading="lazy"/></a>
				<a href="/BookDesign/TheVanishingDeep"><img className="designImage"src={TheVanishingDeep} loading="lazy"/></a>
				<a href="/BookDesign/ZylaandKai"><img className="designImage"src={ZylaandKai} loading="lazy"/></a>
				<a href="/BookDesign/MostDazzlingGirlinBerlin"><img className="designImage"src={MostDazzlingGirlinBerlin} loading="lazy"/></a>
				<a href="/BookDesign/Graceling"><img className="designImage"src={Graceling} loading="lazy"/></a>
				<a href="/BookDesign/HowNotToFallinLove"><img className="designImage"src={HNTFIL} loading="lazy"/></a>
			</div>
		</div>

	)
}

export default YoungAdult